import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "d-flex align-center" }
const _hoisted_2 = {
  class: "my-3 d-flex align-center",
  style: {"gap":"0.5rem"}
}
const _hoisted_3 = { style: {"width":"160px"} }
const _hoisted_4 = { class: "d-flex align-center justify-space-between" }
const _hoisted_5 = { class: "text-overline text-grey" }
const _hoisted_6 = { class: "text-h6 font-weight-bold" }
const _hoisted_7 = {
  class: "d-flex flex-column",
  style: {"gap":"0.4rem"}
}
const _hoisted_8 = { class: "d-flex align-center justify-space-between" }
const _hoisted_9 = { class: "text-body-1 font-weight-bold text-primary" }
const _hoisted_10 = { class: "d-flex align-center justify-space-between" }
const _hoisted_11 = { class: "text-body-1 font-weight-bold text-amber-darken-3" }
const _hoisted_12 = { class: "d-flex align-center justify-space-between" }
const _hoisted_13 = { class: "text-body-1 font-weight-bold text-grey-darken-1" }
const _hoisted_14 = {
  class: "d-flex",
  style: {"gap":"0.4rem"}
}
const _hoisted_15 = {
  key: 0,
  class: "mt-2 text-caption text-grey"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_alert = _resolveComponent("v-alert")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_page_title, { value: "VEVOレポート" })
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_v_select, {
          "hide-details": "",
          density: "compact",
          variant: "outlined",
          items: _ctx.yearOptions,
          modelValue: _ctx.year,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.year) = $event))
        }, null, 8, ["items", "modelValue"])
      ]),
      _cache[1] || (_cache[1] = _createElementVNode("span", { class: "text-body-2 text-grey" }, " 各クォーター (3か月) ごとに、園児単位で発達記録を元にしたVEVOレポートを生成します。 ", -1))
    ]),
    (_ctx.isFetching)
      ? (_openBlock(), _createBlock(_component_v_progress_linear, {
          key: 0,
          indeterminate: "",
          color: "primary",
          class: "my-3"
        }))
      : _createCommentVNode("", true),
    (_ctx.top)
      ? (_openBlock(), _createBlock(_component_v_row, {
          key: 1,
          class: "my-2"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.top.quarters, (q) => {
              return (_openBlock(), _createBlock(_component_v_col, {
                key: q.quarter,
                cols: "12",
                md: "6",
                lg: "3"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, {
                    variant: "outlined",
                    class: _normalizeClass(["pa-4 h-100", _ctx.cardClass(q)])
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_5, "第" + _toDisplayString(q.quarter) + "クォーター", 1),
                          _createElementVNode("div", _hoisted_6, _toDisplayString(q.monthsLabel), 1)
                        ]),
                        (q.latestBatch && q.latestBatch.status === 'processing')
                          ? (_openBlock(), _createBlock(_component_v_chip, {
                              key: 0,
                              color: "primary",
                              size: "small",
                              label: ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, {
                                  size: "small",
                                  start: ""
                                }, {
                                  default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                                    _createTextVNode("mdi-progress-clock", -1)
                                  ]))]),
                                  _: 1
                                }),
                                _cache[3] || (_cache[3] = _createTextVNode(" 生成中 ", -1))
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _createVNode(_component_v_divider, { class: "my-3" }),
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                          _cache[4] || (_cache[4] = _createElementVNode("span", { class: "text-body-2" }, "公開済", -1)),
                          _createElementVNode("span", _hoisted_9, _toDisplayString(q.publishedCount) + " / " + _toDisplayString(q.totalChildren) + " 名 ", 1)
                        ]),
                        _createElementVNode("div", _hoisted_10, [
                          _cache[5] || (_cache[5] = _createElementVNode("span", { class: "text-body-2" }, "下書き", -1)),
                          _createElementVNode("span", _hoisted_11, _toDisplayString(q.draftCount) + " 名 ", 1)
                        ]),
                        _createElementVNode("div", _hoisted_12, [
                          _cache[6] || (_cache[6] = _createElementVNode("span", { class: "text-body-2" }, "未作成", -1)),
                          _createElementVNode("span", _hoisted_13, _toDisplayString(q.notGeneratedCount) + " 名 ", 1)
                        ]),
                        _createVNode(_component_v_progress_linear, {
                          "model-value": _ctx.publishProgress(q),
                          color: "primary",
                          "bg-color": "grey-lighten-3",
                          height: "6",
                          rounded: "",
                          class: "mt-2"
                        }, null, 8, ["model-value"])
                      ]),
                      _createVNode(_component_v_divider, { class: "my-3" }),
                      _createElementVNode("div", _hoisted_14, [
                        _createVNode(_component_v_btn, {
                          color: "primary",
                          variant: "flat",
                          block: "",
                          to: _ctx.quarterPath(q.quarter)
                        }, {
                          default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                            _createTextVNode(" 詳細を開く ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["to"])
                      ]),
                      (q.latestBatch && q.latestBatch.finishedAt)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, " 最終実行: " + _toDisplayString(_ctx.formatDateTime(q.latestBatch.finishedAt)), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1032, ["class"])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (!_ctx.isFetching && _ctx.top && _ctx.top.quarters.every(_ctx.isQuarterEmpty))
      ? (_openBlock(), _createBlock(_component_v_alert, {
          key: 2,
          type: "info",
          variant: "outlined",
          class: "mt-4"
        }, {
          default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
            _createTextVNode(" この年度はまだレポートが生成されていません。詳細を開いて一括生成を実行してください。 ", -1)
          ]))]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}